var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 9.1H10.18V11.83H16.69C16.36 15.64 13.19 17.27 10.19 17.27C6.36 17.27 3 14.25 3 10C3 5.9 6.2 2.73 10.2 2.73C13.29 2.73 15.1 4.7 15.1 4.7L17 2.72C17 2.72 14.56 0 10.1 0C4.42 0 0.0299988 4.8 0.0299988 10C0.0299988 15.05 4.16 20 10.25 20C15.6 20 19.5 16.33 19.5 10.91C19.5 9.76 19.35 9.1 19.35 9.1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogoBlack);
export default __webpack_public_path__ + "static/media/googleLogoBlack.a7d53d563533fb94a11348eefbfa4ed3.svg";
export { ForwardRef as ReactComponent };